import { render } from "./registrationDetail.vue?vue&type=template&id=2c53253b&scoped=true"
import script from "./registrationDetail.vue?vue&type=script&lang=js"
export * from "./registrationDetail.vue?vue&type=script&lang=js"

import "./registrationDetail.vue?vue&type=style&index=0&id=2c53253b&scoped=true&lang=css"

import exportComponent from "D:\\01.Works\\BoonRock\\114.X1Studio\\001.PMS\\31.Dev\\99_source\\crm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c53253b"]])

export default __exports__